import React from 'react';

import './callout.css'

export interface CalloutProps extends React.HTMLProps<HTMLDivElement> {
  /**
   * Determines the border color and text color.
   */
  variant?: "info" | "error" | "success",
};

export function Callout(props: CalloutProps) {

  const { className="", children, variant = "info", ...htmlProps } = props

  return (
    <aside {...htmlProps} className={`callout-box ${variant} ${className}`}>
      {children}
    </aside>
  );
}